import _taggedTemplateLiteral from "/usr/src/app/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
import { useSelect } from "downshift";
import { func, object, string, array } from "prop-types";
import Styled from "styled-components";
var Container = Styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tmargin-right: 10px;\n"])));
var LabelWrapper = Styled.label(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tfont-size: 16px;\n\tcolor: rgb(151,150,160);\n"])));
var TriggerButtonContainer = Styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\twidth: 120px;\n\tmargin: auto;\n\tborder-bottom: 1px solid rgb(237,234,250);\n"])));
var TriggerButton = Styled.button(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\twidth: 100%;\n\tmax-width :400px;\n\tpadding: 6px 22px 6px 12px;\n\tborder-radius: 10px;\n\ttext-align: left;\n\toutline: none;\n\tborder: 0;\n\tbackground-color: transparent;\n\tfont-family: \"Proxima Nova\";\n\tfont-size: 13px;\n\tfont-weight: normal;\n\tfont-stretch: normal;\n\tfont-style: normal;\n\tline-height: 1.55;\n\tletter-spacing: normal;\n\tcolor: #000;\n\tposition: relative;\n"])));
var ArrowIcon = Styled.span(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\tborder: solid #7d60ff;\n\tborder-width: 0 1px 1px 0;\n\tpadding: 3px;\n\tfloat: right;\n\tdisplay: inline-block;\n\ttransform: ", ";\n\ttransition: transform 0.1s linear;\n\tposition: absolute;\n\tright: 12px;\n\ttop: 35%;\n  "])), function (props) {
  return props.isOpen ? "rotate(225deg)" : "rotate(45deg)";
});
var MenuList = Styled.ul(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n\tmax-height: 200px;\n\twidth: 100%;\n\tmax-width : 400px;\n\toverflow-y: auto;\n\tmargin: 0 auto;\n\tborder-top: 0;\n\toutline: none;\n\tpadding: 0;\n\tborder-radius: 0 0 10px 10px;\n\tbox-shadow: 0 2px 4px 0 rgba(219, 221, 227, 0.5);\n\tbackground-color: #ffffff;\n"])));
var MenuListItem = Styled.li(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n\tpadding: 4px 10px;\n\ttext-align: left;\n\tlist-style-type: none;\n\tborder-bottom: 1px solid #edeafa;\n\tfont-family: \"Proxima Nova\";\n\tfont-size: 13px;\n\tfont-weight: normal;\n\tfont-stretch: normal;\n\tfont-style: normal;\n\tline-height: 1.85;\n\tletter-spacing: normal;\n\tbackground-color: ", ";\n  \tcolor: ", ";\n\n\t&:last-child {\n\t\tborder-bottom: 0;\n\t}\n"])), function (props) {
  return props.selectedItem ? "#edeafa" : props.highlightedIndex ? "#f8f8ff" : "#fffff";
}, function (props) {
  return props.selectedItem ? "#7d60ff" : "#9796a0";
});
export var Dropdown = function Dropdown(_ref) {
  var items = _ref.items,
      title = _ref.title,
      label = _ref.label,
      onChange = _ref.onChange,
      containerStyle = _ref.containerStyle,
      menuStyle = _ref.menuStyle,
      initialSelectedItem = _ref.initialSelectedItem,
      customListItemRender = _ref.customListItemRender;

  var _useSelect = useSelect({
    items: items,
    itemToString: function itemToString(item) {
      return item ? item.value : "";
    },
    onSelectedItemChange: function onSelectedItemChange(e) {
      onChange(e.selectedItem);
    },
    initialSelectedItem: initialSelectedItem
  }),
      isOpen = _useSelect.isOpen,
      selectedItem = _useSelect.selectedItem,
      getToggleButtonProps = _useSelect.getToggleButtonProps,
      getLabelProps = _useSelect.getLabelProps,
      getMenuProps = _useSelect.getMenuProps,
      highlightedIndex = _useSelect.highlightedIndex,
      getItemProps = _useSelect.getItemProps;

  return /*#__PURE__*/React.createElement(Container, {
    style: containerStyle
  }, title ? /*#__PURE__*/React.createElement(LabelWrapper, getLabelProps(), title) : null, /*#__PURE__*/React.createElement(TriggerButtonContainer, null, /*#__PURE__*/React.createElement(TriggerButton, getToggleButtonProps({
    type: "button"
  }), selectedItem && selectedItem.label || label, /*#__PURE__*/React.createElement(ArrowIcon, {
    isOpen: isOpen
  }))), /*#__PURE__*/React.createElement(MenuList, _extends({}, getMenuProps(), {
    style: menuStyle
  }), isOpen && items.map(function (item, index) {
    return /*#__PURE__*/React.createElement(MenuListItem, _extends({
      highlightedIndex: highlightedIndex === index,
      selectedItem: selectedItem.value === item.value,
      key: "".concat(item.value).concat(index)
    }, getItemProps({
      item: item,
      index: index
    })), customListItemRender ? customListItemRender(item) : item.label);
  })), /*#__PURE__*/React.createElement("div", {
    tabIndex: "0"
  }));
};
Dropdown.propTypes = {
  onChange: func.isRequired,
  items: array.isRequired,
  label: string.isRequired,
  containerStyle: object,
  menuStyle: object
};
Dropdown.defaultProps = {
  items: [],
  label: "",
  onChange: function onChange() {},
  containerStyle: {},
  menuStyle: {}
};